@use 'sass:color' as sassColor;
@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

$status-color: (
  'fail'$color-primary-red $color-primary-red $color-primary-red-hover 0.7 0.96,
  'pass'$color-secondary-green $color-secondary-green $color-secondary-green 0.8 0.96,
  'passAfterRerun'$color-secondary-green $color-secondary-green $color-secondary-green 0.7 0.96,
  'error'$color-warning-orange $color-warning-orange $color-warning-orange 0.7 0.96,
  'pending'$color-secondary-button-border $color-grey-B $color-grey-B 0 0.96,
  'unsuccessful'$color-primary-red $color-primary-red $color-primary-red-hover 0.7 0.96,
  'verified'$color-secondary-green $color-secondary-green $color-secondary-green 0.7 0.96,
  'unassigned'$color-secondary-button-border $color-grey-A $color-grey-C 0 0.96,
  'untested'$color-secondary-button-border $color-grey-B $color-grey-B 0 0.96,
  'inProgress'$color-secondary-button-border $color-grey-B $color-grey-B 0 0.96,
  'ignore'$color-secondary-button-border $color-grey-B $color-grey-C 0 0.96,
  'skipped'$color-secondary-button-border $color-grey-B $color-grey-B 0 0.96
);

.StatusChip {
  @extend %font-family-primary;

  font-size: $font-size-normal;
  font-weight: $font-weight-semibold;
  display: inline-flex;
  align-items: center;
  column-gap: 6px;
  padding: 4px 8px;
  border-radius: 6px;
  border-style: solid;
  border-width: 1px;
  width: max-content;
  color: $theme-color-statuschip-text;

  &.isParentMaxHeight {
    display: grid;
    grid-auto-flow: column;
    height: 100%;
    padding: 0 8px;
  }

  @each $name,
  $border-color,
  $background-color,
  $svg-color,
  $border-opacity,
  $background-opacity in $status-color {
    &.#{$name} {
      border-color: sassColor.adjust($border-color, $alpha: -$border-opacity);
      background-color: sassColor.adjust($background-color, $alpha: -$background-opacity);
      .iconColor {
        display: inline-flex;

        svg {
          color: $svg-color;
        }
      }
    }
  }

  &.inProgress {
    border-color: sassColor.adjust($color-primary-purple, $alpha: -0.7);
    background-color: $theme-statuschip-inprogress;

    svg {
      color: $color-primary-purple;
    }
  }

  &.cancelled {
    border-color: $theme-statuschip-cancelled-border;
    background-color: $theme-statuschip-ignore-background;

    .iconColor {
      display: inline-flex;

      svg {
        color: $theme-color-dnd-icon;
      }
    }
  }

  &.fail {
    border-color: $theme-statuschip-fail-border;
    background-color: $theme-statuschip-fail-background;
  }

  &.pass {
    border-color: $theme-statuschip-pass-border;
    background-color: $color-secondary-green-10;
  }

  &.error {
    border-color: $theme-statuschip-error-border;
    background-color: $color-warning-orange-10;
  }

  &.untested {
    border-color: $theme-color-table-border;
    background-color: $theme-statuschip-untested-border;

    .iconColor {
      display: inline-flex;

      svg {
        color: $theme-color-dnd-icon;
      }
    }
  }

  &.ignore {
    border-color: $theme-color-table-border;
    background-color: $theme-statuschip-ignore-background;

    .iconColor {
      display: inline-flex;

      svg {
        color: $theme-color-dnd-icon;
      }
    }
  }

  &.skipped {
    border-color: $theme-color-table-border;
    background-color: $theme-statuschip-untested-border;

    .iconColor {
      display: inline-flex;

      svg {
        color: $theme-color-dnd-icon;
      }
    }
  }

  &.locked {
    border-color: sassColor.adjust($color-primary-purple, $alpha: -0.7);
    background-color: $theme-statuschip-inprogress;

    svg {
      color: $color-primary-purple;
    }
  }

  .Divider {
    background-color: $theme-color-divider;
    width: 1px;
    align-self: stretch;
  }
}

.iconButton {
  display: flex;
  justify-content: center;
  align-items: end;
  background-color: transparent;
  border: 0px;
  padding: 0px;
  cursor: pointer;
}